<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    :return-value.sync="date"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :error-messages="error"
      v-model="date"
      :label="label"
      prepend-icon="mdi-calendar"
      :box="box"
      :solo="solo"
      :readonly="readOnlyText"
    ></v-text-field>
    <v-date-picker locale="es-es" v-model="date" :type="'month'">
      <v-spacer></v-spacer>
      <v-btn
        flat
        color="error"
        @click="
          date = null;
          $refs.menu.save(date);
        "
      >
        {{ $t('Delete') }}
      </v-btn>

      <v-btn flat color="primary" @click="menu = false">
        {{ $t('Cancel') }}
      </v-btn>
      <v-btn flat color="primary" @click="$refs.menu.save(date)">
        {{ $t('OK') }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    label: String,
    value: String,
    solo: Boolean,
    readOnlyText: {
      type: Boolean,
      default: true,
    },
    box: {
      type: Boolean,
      default: true,
    },
    error: {
      type: String,
    },
  },
  data() {
    return {
      date: this.value,
      menu: false,
    };
  },
  mounted() {},

  watch: {
    date: function(val, oldVal) {
      this.$emit('input', this.date);
    },
    value: function(val) {
      this.date = val;
    },
  },
};
</script>

<style></style>
